const DEFAULT_MEETING_DURATION = '40'

export const getFreeUserMeetingMinutes = () => window.newBillingConfig?.freeUserMeetingMinute || DEFAULT_MEETING_DURATION
